import React from 'react'
import {Icon} from '@chakra-ui/react'

const CheckIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" fill="transparent" data-testid="check-icon" {...props}>
            <path
                d="M33.542 5L14.4831 27.8675L5.87369 20.9804L3.33398 24.1565L15.0565 33.5366L36.6673 7.60477L33.542 5Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default CheckIcon
